"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentLibraryDocumentStatus = exports.ContentLibraryType = exports.ContentLibrarySortOrder = exports.ContentLibrarySortFields = void 0;
var ContentLibrarySortFields;
(function (ContentLibrarySortFields) {
    ContentLibrarySortFields["created_at"] = "CREATED_AT";
    ContentLibrarySortFields["modified_at"] = "MODIFIED_AT";
})(ContentLibrarySortFields = exports.ContentLibrarySortFields || (exports.ContentLibrarySortFields = {}));
var ContentLibrarySortOrder;
(function (ContentLibrarySortOrder) {
    ContentLibrarySortOrder["ASCENDING"] = "ASC";
    ContentLibrarySortOrder["DESCENDING"] = "DESC";
})(ContentLibrarySortOrder = exports.ContentLibrarySortOrder || (exports.ContentLibrarySortOrder = {}));
var ContentLibraryType;
(function (ContentLibraryType) {
    ContentLibraryType["DOCUMENT"] = "DOCUMENT";
    ContentLibraryType["QA"] = "QA";
})(ContentLibraryType = exports.ContentLibraryType || (exports.ContentLibraryType = {}));
var ContentLibraryDocumentStatus;
(function (ContentLibraryDocumentStatus) {
    ContentLibraryDocumentStatus["IN_PROGRESS"] = "IN_PROGRESS";
    ContentLibraryDocumentStatus["ERROR"] = "ERROR";
    ContentLibraryDocumentStatus["DONE"] = "DONE";
})(ContentLibraryDocumentStatus = exports.ContentLibraryDocumentStatus || (exports.ContentLibraryDocumentStatus = {}));
